export default __webpack_public_path__ + "static/media/8_ceramics.412975ad.png";